<template>
    <v-form style="height: 100vh" v-model="valid">
        <v-container class="login-container" fluid>
            <v-row style="height: 100% !important;">
                <v-col class="pa-12 d-flex align-center" cols="6">
                    <v-container>
                        <h1>{{ $t('great',{firstName: firstName}) }}</h1>
                        <h3>{{ $t('greetings')}}</h3>
                        <br>
                        <v-row>
                            <v-col cols="6">
                                <v-text-field :label="$t('phoneNumber')" outlined :rules="phoneNumberRule" v-model="phoneNumber"/>
                            </v-col>
                            <v-col cols="6">
                                <v-autocomplete :items="countries" :label="$t('country')" item-text="name" item-value="name" outlined :rules="countryRule" v-model="country"/>
                            </v-col>
                        </v-row>

                        <v-divider class="mb-5 mt-2"/>

                        <v-row>
                            <v-col cols="6">
                                <h3>{{ $t('howDidYouMeetUs') }}</h3>
                                <v-select :items="channels" item-text="text" item-value="value" :rules="channelRule" :label="$t('channel')" outlined v-model="channelChoosed"/>
                                <h3>{{ $t('inWhichMarketsDoYouTradeIn') }}</h3>
                                <v-select :items="this.$store.state.markets" item-text="name" chips :hint="$t('markets')" multiple outlined persistent-hint v-model="marketsChoosed"/>
                            </v-col>
                            <v-col cols="6">
                                <h3>{{ $t('whatKindOfTrader.header') }}</h3>
                                <v-select :items="traderType" item-text="text" item-value="value" :rules="traderTypeRule" :label="$t('whatKindOfTrader.label')" outlined v-model="traderTypeChoosed"/>
                                <h3>{{ $t('inWhichBrokerDoYouHaveAnAccount') }}</h3>
                                <v-autocomplete :items="brokers" item-text="name" item-value="id" chips hint="Brokers" outlined persistent-hint v-model="brokersChoosed"/>
                            </v-col>
                        </v-row>

                        <v-row class="mt-5">
                            <v-col>
                                <v-btn @click="backStep">« {{ $t('finalButtons.back') }}</v-btn>
                                <v-btn class="submit-button ml-7" @click="nextStep">{{ $t('finalButtons.finish') }}</v-btn>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col>
                                <p style="color: #585a61" v-html="$t('submission')"></p>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-col>
                <v-col class="signup-image" cols="6"></v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
    import CountriesData from '../countries';
    import axios from 'axios';
    import Repository from '../../../repositories/auth';

    export default {
        name: "BasicData",
        props: {
            firstName: String,
            lastName: String,
            email: String,
            username: String,
            password: String,
            referredFrom: String,
            plan: String,
            landingKey: String,
            discount: Number,
        },
        data() {
            return {
                countries: CountriesData,
                channels: [
                    { text: 'Instagram', value: 'Instagram'},
                    { text: 'Facebook', value: 'Facebook'},
                    { text: 'Youtube', value: 'Youtube'},
                    { text: 'Webinar', value: 'Webinar'},
                    { text: this.$t('channels.wordOfMouth'), value: 'Word-of-Mouth'},
                    { text: this.$t('channels.googleSearch'), value: 'Google Search'},
                    { text: this.$t('channels.academyPartnership'), value: 'Academy Partnership'},
                    { text: this.$t('channels.brokerPartnership'), value: 'Broker Partnership'},
                    { text: this.$t('channels.other'), value: 'Other'}
                ],
                traderType: [
                    { text: 'Swing Trader', value: 'Swing Trader'},

                    { text: 'Day Trader', value: 'Day Trader' },
                    { text: 'Core Trader', value: 'Core Trader'},
                    { text: this.$t('traderTypes.highFrequencyTrader'), value: 'High-Frecuency Trader'},
                    { text: this.$t('traderTypes.iDontKnow'), value: 'I don\'t know'},
                ],
                assets: {},
                brokers: [],

                //data
                channelChoosed: '',
                traderTypeChoosed: '',
                marketsChoosed: [],
                brokersChoosed: [],
                phoneNumber: '',
                country: '',

                //confirmation data
                titleMessage: 'An email was sent with the activation link',
                bodyMessage: 'Your account was successfully created. Please confirm your email address, is mandatory to login and start using Swiset.',
                goToMessage: 'Go to Login',
                afterConfirmationRoute: '',

                // Rules
                valid: false,
                phoneNumberRule: [
                    p => !!p || this.$t('fieldRules.phone'),
                ],
                countryRule: [
                    c => !!c || this.$t('fieldRules.country'),
                ],
                channelRule: [
                    c => !!c || this.$t('fieldRules.channel'),
                ],
                traderTypeRule: [
                    t => !!t || this.$t('fieldRules.traderType'),
                ],
            };
        },
        mounted() {
            this.verifyPreviousData();
            this.loadBrokers();
        },
        methods: {
            verifyPreviousData() {
                if(
                    this.firstName == null || this.firstName === '' ||
                    this.lastName == null || this.lastName === '' ||
                    this.email == null || this.email === '' ||
                    this.username == null || this.username === '' ||
                    this.password == null || this.password === ''
                )
                    this.$router.push("/register")
            },
            async loadBrokers() {
                let finished = false;
                for(let i = 0; !finished; i++)
                    await axios.get(`${this.$store.state.backend}/brokers?page=${i}`).then(
                        (response) =>  {
                            if(response.data.length > 0)
                                response.data.forEach((item) => { this.brokers.push(item); });
                            else
                                finished = true;
                        });
                this.brokers.sort((one, two) => (one.name > two.name)? 1 : (one.name < two.name)? -1 : 0);
            },
            nextStep() {
                if (this.valid) {
                    // For create an array that is expected in backend
                    let brokersToRegister = [];
                    brokersToRegister.push(this.brokersChoosed);
                    let userData = {
                        firstName: this.firstName,
                        lastName: this.lastName,
                        email: this.email,
                        username: this.username,
                        password: this.password,
                        phoneNumber: this.phoneNumber,
                        country: this.country,
                        brokers: brokersToRegister,
                        typeOfTrader: this.traderTypeChoosed,
                        channel: this.channelChoosed,
                        referredFrom: this.referredFrom,
                        langKey: this.$i18n.locale,
                    };

                  // eslint-disable-next-line no-unreachable
                    Repository.registerUser(userData).then((response) => {
                        if(response.status < 400){
                            // if(this.plan){
                            //     this.$router.push({
                            //         name: 'subscription-plans',
                            //     });
                            // }else{
                                window.sendinblue.identify(this.email, {
                                  'NOMBRE': this.firstName,
                                  'SURNAME' : this.lastName,
                                  'USERNAME': this.username,
                                  'PHONE': this.phoneNumber,
                                  'COUNTRY': this.country,
                                  'PRO_ON' : '0',
                                  'LANG': this.$i18n.locale,
                                  'USAGE_STATE': 'REGISTERED',
                                  'COMMERCIAL_STATE': 'NEVER_PRO',
                                });
                                window.fbq('track', 'SubmitApplication');
                                window.fbq('trackCustom', 'VirtualPageView',
                                    { url: (this.landingKey !== '')? `/registration-confirmation-${this.landingKey}` : '/registration-confirmation' });
                                if(this.country == 'Colombia') {
                                    this.$router.push({
                                        name: 'confirmation',
                                        params: { titleMessage: this.titleMessage, bodyMessage: this.bodyMessage, goToMessage: this.goToMessage,
                                            afterConfirmationRoute: this.afterConfirmationRoute}
                                    });
                                } else {
                                    this.$router.push({
                                        name: 'subscription-plans-collapsed',
                                        params: {
                                            userId: Number.parseInt(response.data.id),
                                            highlight: this.plan,
                                            discount: Number.parseInt(this.discount)
                                        }
                                    });
                                }
                            // }
                        }
                    });
                }
                else
                    alert(this.$t('alertMessage'));
            },
            backStep() {
                this.$router.push("/register");
            },
        },
    }
</script>

<style scoped>
    .login-container {
        height: 100% !important;
        padding: 0 !important;
        margin: 0 !important;
    }
    .signup-image{
        padding: 0;
        background-color: #111111;
        background-image: url("https://swiset.com/wp-content/uploads/2020/05/Trading-Journal-Free.png");
        background-repeat: no-repeat;
        background-size: contain, cover;
        background-position: right;
    }
    .submit-button {
        background-color: #111111 !important;
        color: #FFFFFF !important;
    }
</style>


<i18n>
{
  "en": {
    "great": "Great {firstName}!",
    "greetings": "We will ask you some quick questions to personalize your experience.",
    "phoneNumber": "Phone number",
    "country": "Country",
    "howDidYouMeetUs": "How did you meet us?",
    "channel": "Channel",
    "inWhichMarketsDoYouTradeIn": "In which markets do you trade in?",
    "markets": "Markets",
    "whatKindOfTrader":{
     "header": "What kind of trader are you?",
     "label": "Type of trader"
    },
    "inWhichBrokerDoYouHaveAnAccount": "In which broker do you have an account?",
    "finalButtons":{
        "back": "Back",
        "finish": "Finish"
    },
    "submission": "By submitting, you agree with our <a href='https://swiset.com/terms-and-conditions' target='_blank'>terms and conditions</a>.",
    "alertMessage": "There are one or more mandatory fields that are not filled.",

    "channels":{
        "wordOfMouth": "Word-of-Mouth",
        "googleSearch": "Google Search",
        "academyPartnership": "Academy Partnership",
        "brokerPartnership": "Broker Partnership",
        "other": "Other"
    },

    "traderTypes":{
      "iDontKnow": "I don't know",
      "highFrequencyTrader": "High-Frecuency Trader"
    },

    "fieldRules":{
      "lastName": "Last name is required",
      "phone": "Phone is required",
      "country": "Country is required",
      "channel": "Channel is required",
      "traderType": "Trader Type is required"
    }
  },

  "es":{
    "great": "Genial {firstName}!",
    "greetings": "Te haremos unas preguntas rapidas para personalizar tu experiencia.",
    "phoneNumber": "Número telefónico",
    "country": "País",
    "howDidYouMeetUs": "¿Cómo nos conociste?",
    "channel": "Canal",
    "inWhichMarketsDoYouTradeIn": "¿En que mercados operas?",
    "markets": "Mercados",
    "whatKindOfTrader":{
      "header": "¿Qué tipo de trader eres?",
      "label": "Tipo de trader"
    },
    "inWhichBrokerDoYouHaveAnAccount": "¿En que broker tienes cuenta?",
    "finalButtons":{
        "back": "Atras",
        "finish": "Finalizar"
    },
    "submission": "Al enviar, aceptas nuestros  <a href='https://swiset.com/terms-and-conditions' target='_blank'>terminos y condiciones</a>.",
    "alertMessage": "Hay uno o más campos sin completar.",

    "channels":{
        "wordOfMouth": "Voz a voz",
        "googleSearch": "Busqueda en Google",
        "academyPartnership": "Alianza con Academia",
        "brokerPartnership": "Alianza con Broker",
        "other": "Otro"
    },

    "traderTypes":{
      "iDontKnow": "No lo sé",
      "highFrequencyTrader": "Trader de alta frecuencia"
    },

    "fieldRules":{
      "lastName": "El apellido es obligatorio",
      "phone": "El número telefónico es obligatorio",
      "country": "El país es obligatorio",
      "channel": "El canal es obligatorio",
      "traderType": "El tipo de trader es obligatorio"
    }

  }
}
</i18n>
